<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :is-required="isRequired"
    :class-label="classLabel"
    :class-wrapper="classWrapper"
  >
    <FieldInput
      :value="value"
      :state="state"
      :suffix="suffix"
      :prefix="prefix"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :debounce="debounce"
      v-model="text"
    >
      <template
        v-if="$scopedSlots['append']"
        #append="props"
      >
        <slot
          name="append"
          :props="props"
        />
      </template>
    </FieldInput>
  </FieldWrapper>
</template>

<script>
import FieldInput from '@/components/forms/FieldInput'
import FieldWrapper from '@/components/forms/FieldWrapper'

export default {
  components: {
    FieldInput,
    FieldWrapper
  },

  props: {
    value: {},

    state: {
      type: Object
    },

    label: {
      type: String
    },

    placeholder: {
      type: String
    },

    isRequired: {
      type: Boolean
    },

    disabled: {
      type: Boolean,
      default: false
    },

    maxlength: {
      type: Number
    },

    classLabel: {
      type: String
    },

    classWrapper: {
      type: String
    },

    suffix: {
      type: String
    },

    prefix: {
      type: String
    },

    type: {
      type: String,
      default: 'text'
    },

    debounce: {
      type: Number,
      default: 100
    }
  },

  data () {
    return {
      text: forceStr(this.value)
    }
  },

  watch: {
    text (text) {
      if (isEqual(text, this.value)) return
      this.$emit('input', forceStr(text))
    },

    value (value) {
      if (isEqual(this.text, value)) return
      this.text = forceStr(value)
    }
  }
}

const forceStr = (val) => String(val || '')
const isEqual = (source, target) => forceStr(source) === forceStr(target)
</script>
